{
  "name": "client-app",
  "version": "2.10.5",
  "scripts": {
    "ng": "ng",
    "debug": "ng s",
    "serve:prod-local": "ng serve --configuration prod-local",
    "start": "echo installing deps... && echo running... && ng serve",
    "hmr": "ng serve --hmr",
    "build": "cross-env NODE_ENV=production ng build --configuration prod",
    "build-dev": "cross-env NODE_ENV=dev ng build --configuration dev",
    "build-alfa": "cross-env NODE_ENV=alfa ng build --configuration alfa",
    "build-stage": "cross-env NODE_ENV=stage ng build --configuration stage",
    "build-prod": "cross-env NODE_ENV=prod ng build --configuration prod",
    "build-prod_credem": "cross-env NODE_ENV=prod_credem ng build --configuration prod_credem",
    "test": "ng test",
    "lint": "ng lint",
    "lint-fix": "npx eslint . --fix",
    "e2e": "ng e2e",
    "swagger:update": "ng-openapi-gen --config swagger-config.json"
  },
  "private": true,
  "browser": {
    "fs": false,
    "path": false,
    "os": false
  },
  "dependencies": {
    "@angular/animations": "^21.2.22",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.22",
    "@angular/compiler": "^21.2.22",
    "@angular/core": "^21.2.22",
    "@angular/forms": "^21.2.22",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.22",
    "@angular/platform-browser-dynamic": "^21.2.22",
    "@angular/router": "^21.2.22",
    "@ckeditor/ckeditor5-angular": "^11.1.2",
    "@microsoft/signalr": "^10.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "bootstrap": "^5.3.8",
    "ckeditor5": "^48.1.1",
    "cross-env": "^10.1.0",
    "error-stack-parser": "^2.1.4",
    "jwt-decode": "^4.0.0",
    "moment": "^2.30.1",
    "ng-openapi-gen": "^1.0.5",
    "ng2-pdfjs-viewer": "^18.0.0",
    "ngx-cookie-service": "^21.3.1",
    "ngx-file-drop": "^16.0.0",
    "ngx-skeleton-loader": "^12.0.0",
    "ngx-ui-tour-md-menu": "^16.0.0",
    "object-hash": "^3.0.0",
    "rxjs": "^7.8.2",
    "sanitize-html": "^2.17.1",
    "source-map": "^0.7.6",
    "stacktrace-gps": "^3.1.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.22",
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/cli": "^21.2.22",
    "@angular/compiler-cli": "^21.2.22",
    "@eslint/compat": "^2.1.0",
    "@eslint/eslintrc": "^3.3.5",
    "@eslint/js": "^10.0.1",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@popperjs/core": "^2.11.8",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/typography": "^0.5.19",
    "@types/jasmine": "^5.1.13",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^22.19.19",
    "@types/object-hash": "^3.0.6",
    "@types/sanitize-html": "^2.16.1",
    "@typescript-eslint/eslint-plugin": "^8.59.4",
    "@typescript-eslint/parser": "^8.59.4",
    "autoprefixer": "^10.4.22",
    "codelyzer": "^6.0.2",
    "eslint": "^10.4.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "jasmine-core": "^5.13.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "postcss": "^8.5.6",
    "prettier": "^3.7.4",
    "prettier-eslint": "^16.4.2",
    "prettier-plugin-tailwindcss": "^0.5.14",
    "protractor": "~7.0.0",
    "tailwindcss": "^3.4.19",
    "ts-node": "^10.9.2",
    "tslint": "~6.1.3",
    "typescript": "~5.9.3"
  }
}
